var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.$style.logout,attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.log($event)}}},[(_vm.media !== 'desktop')?_c('span',[_vm._v("Выйти")]):_c('Icon',{class:_vm.$style.svg})],1)}
var staticRenderFns = []

export { render, staticRenderFns }